import React from 'react'
import { AddRateFlowProvider } from './context/AddRateFlowProvider'
import { AddRateFlowMain } from './components/AddRateFlowMain'
import { useRuleDetailContextValue } from '../../context/RuleDetailProvider'

export const AddRateFlow = () => {
  const {
    state: { id: ruleId },
  } = useRuleDetailContextValue()

  return (
    <AddRateFlowProvider ruleId={ruleId}>
      <AddRateFlowMain />
    </AddRateFlowProvider>
  )
}
